<table aria-label="policy-documents-table" class="table" *ngIf="showTableDocs">
    <thead class="bg-light">
        <tr>
            <th scope="col">Documento</th>
            <th scope="col">Data inserimento</th>
            <th scope="col">Download</th>
        </tr>
    </thead>
    <tbody>
        <ng-container *ngFor="let document of documentsList">
            <tr>
                <td>{{ document.description }}</td>
                <td>{{ document.insertDate }}</td>
                <td>
                    <mat-icon class="download-icon" aria-hidden="false" aria fontIcon="download" (click)="downloadDocument(document)"></mat-icon>
                </td>
            </tr>
        </ng-container>
    </tbody>
</table>